const Task = () => import('@/modules/task/views/Task.vue')

export const taskRoutes = [
	{
		path: '/task',
		component: Task,
		children: [{ name: 'task', path: '/' }, { name: 'calendar', path: 'calendar' }]
	}
]
